/**
 * Rutas cuyo contenido es un recurso interno del tenant (OT-0015): el
 * catálogo de plantillas —con su prompt engineering— y las metodologías que
 * lo agrupan, el padrón de usuarios y la base de conocimiento.
 *
 * Cada una pasa por `TierGate` con `canReadTenantInternalResources`, espejo de
 * `require_tenant_internal_resources_read` en backend. El router monta estos
 * componentes, nunca las vistas directamente.
 *
 * Límite conocido. El gate decide con el tier que trae `/me`. Si el tier
 * cambia con la sesión abierta, cada vista reconoce el `403 FORBIDDEN_TIER`
 * de su propia lectura y muestra `NoAccessView` en lugar del contenido, pero
 * nada refresca `/me` por eso: el tier global se actualiza cuando `/me` se
 * vuelve a pedir, y los datos ya cargados en otras queries no se revocan al
 * instante.
 */

import type { MeResponse } from '../api/me'
import { TierGate } from '../auth/TierGate'
import { canReadTenantInternalResources } from '../lib/tiers'
import { MethodologyDetailView } from './MethodologyDetailView'
import { TemplateDetailView } from './TemplateDetailView'
import { TemplatesView } from './TemplatesView'
import { TenantSourcesView } from './settings/TenantSourcesView'
import { TenantTeamView } from './settings/TenantTeamView'

function canReadInternal(me: MeResponse): boolean {
  return canReadTenantInternalResources(me.role)
}

export function TemplatesRoute() {
  return (
    <TierGate allow={canReadInternal}>
      <TemplatesView />
    </TierGate>
  )
}

export function TemplateDetailRoute() {
  return (
    <TierGate allow={canReadInternal}>
      <TemplateDetailView />
    </TierGate>
  )
}

export function MethodologyDetailRoute() {
  return (
    <TierGate allow={canReadInternal}>
      <MethodologyDetailView />
    </TierGate>
  )
}

export function TenantTeamRoute() {
  return (
    <TierGate allow={canReadInternal}>
      <TenantTeamView />
    </TierGate>
  )
}

export function TenantSourcesRoute() {
  return (
    <TierGate allow={canReadInternal}>
      <TenantSourcesView />
    </TierGate>
  )
}
